// Homepage "logos" defaults (EN + FR): the client-logo band (src/Sections/WhyChooseUs).
// The logos themselves are built into that component (src/assets/home/whyChooseUs/companiesServed)
// until logos are added in the admin; logos and client names are stored once (English side).
const LOGOS_DEFAULTS = {
  "en": { "label": "Trusted by Industry Leaders", "ariaLabel": "Companies served" },
  "fr": { "label": "Ils nous font confiance", "ariaLabel": "Entreprises desservies" }
};

export default LOGOS_DEFAULTS;
